import React from "react";
import "./styles.scss";

const NotFound = ({ message }) => {
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="error-template">
              <h1>Oops!</h1>
              <h2>404 Not Found.</h2>
              <div className="error-details">{message}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
